/**
 * Numele unei pagini in telemetrie, derivat din URL.
 *
 * Fara asta, SDK-ul pune pe fiecare PageView titlul documentului - „ECOTIC" peste tot (masurat
 * 2026-09-21: un singur `name` distinct in 1.281 de pageViews), deci gruparea pe pagina se putea
 * face doar dupa URL, cu id-urile si tokenurile in el.
 *
 * Reguli, pe segmente de cale:
 * - UUID sau numar → `{id}`, ca `/lectii/<uuid>` si `/lectii/<alt-uuid>` sa fie aceeasi pagina;
 * - segmentul de dupa `activitate` sau `collab` → `{token}`. Tokenul de colaborator e o credentiala
 *   (vezi `shared/utils/redact-collab-token.ts`); aici se inlocuieste INTREG, fara previzualizarea
 *   de 8 caractere, pentru ca un nume de pagina cu preview ar face o pagina distincta per token.
 *
 * Query string-ul, fragmentul si host-ul (cu sau fara `www.`) nu intra in nume.
 */
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const NUMERIC = /^\d+$/;
const TOKEN_PARENTS = new Set(["activitate", "collab"]);

export function pageNameFromUrl(uri: string | undefined): string | undefined {
    if (!uri) return uri;

    let pathname: string;
    try {
        pathname = new URL(uri, "https://placeholder.invalid").pathname;
    } catch {
        return undefined;
    }

    const segments = pathname.split("/").filter(Boolean);
    const named = segments.map((segment, i) => {
        if (i > 0 && TOKEN_PARENTS.has(segments[i - 1])) return "{token}";
        if (UUID.test(segment) || NUMERIC.test(segment)) return "{id}";
        return segment;
    });

    return "/" + named.join("/");
}
